import useAuth from '../../hooks/useAuth';
import RentVisitDetail from './RentVisitDetail';
import ProperRentVisitDetail from './ProperRentVisitDetail';

// El Proper usa un detalle con sólo sus acciones (endpoints de proper); el
// resto de usuarios internos, el detalle completo.
const RentVisitDetailRoute = () => {
  const { getUserRealm } = useAuth();
  return getUserRealm().toLowerCase() === 'proper' ? (
    <ProperRentVisitDetail />
  ) : (
    <RentVisitDetail />
  );
};

export default RentVisitDetailRoute;
